import { useEffect } from 'react';
import type { Schema } from 'yup';
import { useValidations } from './ValidationsContext';
import { ValidationError } from 'types/api/envScales/ObservationValidations';

export function useFieldError(path: string): ValidationError | null {
  const { errors, showErrorStatus } = useValidations();

  if (!showErrorStatus) {
    return null;
  }

  return errors[path] || null;
}

// Also reports live validity to ValidationsContext on every render, as a
// side effect, so an ancestor section can react without waiting on a refetch.
export function useServerFieldError(
  path: string,
  currentValue: unknown,
  schema: Schema
): ValidationError | null {
  const { reportFieldResolution } = useValidations();
  const error = useFieldError(path);
  const isValidNow = schema.isValidSync(currentValue);

  useEffect(() => {
    reportFieldResolution(path, isValidNow);
  }, [path, isValidNow, reportFieldResolution]);

  return !error || isValidNow ? null : error;
}
